import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { api } from '../../services/api';
import ImageUploader from '../../components/ImageUploader';
import ProgressBar from '../../components/ProgressBar';
import { Input, TextArea } from '../../components/ui/Input';
import { Button } from '../../components/ui/Button';
import { Card, CardContent } from '../../components/ui/Card';

const Container = styled.div`
  max-width: 1000px;
  margin: 0 auto;
`;

const FormGroup = styled.div`
  margin-bottom: 1rem;
  label { display: block; margin-bottom: 0.5rem; font-weight:500; }
`;

const ContactAdmin = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const [progress, setProgress] = useState(0);

  useEffect(() => { loadData(); }, []);

  const loadData = async () => {
    try {
      const res = await api.get('/contact');
      setData(res);
    } catch (err) { console.error(err); } finally { setLoading(false); }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await api.put('/contact', data);
      setMsg('Saved successfully');
    } catch (err) { setMsg('Error saving'); }
    finally { setSaving(false); }
  };

  const handleImage = async (file) => {
    if (!file) return;
    setProgress(0);
    const timer = setInterval(() => {
        setProgress(prev => {
            if(prev < 90) return prev + 10;
            return prev;
        });
    }, 100);

    try {
        const fd = new FormData(); fd.append('image', file);
        const res = await api.upload('/contact/image', fd);
        
        clearInterval(timer);
        setProgress(100);
        
        setData(res);
        setTimeout(() => setProgress(0), 500);
    } catch (err) {
        clearInterval(timer);
        setProgress(0);
        console.error('Image upload failed', err);
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <Container>
      <h2>Manage Contact Page</h2>
      {msg && <div style={{color:'green'}}>{msg}</div>}

      <Card style={{marginBottom:'2rem'}}>
        <CardContent>
          <h3>Header</h3>
          <FormGroup><label>Title</label><Input value={data.title} onChange={e=>setData({...data, title:e.target.value})} /></FormGroup>
          <FormGroup><label>Description</label><TextArea value={data.description} onChange={e=>setData({...data, description:e.target.value})} /></FormGroup>
          <ImageUploader previewUrl={data.image} onImageSelect={handleImage} />
          {progress > 0 && <ProgressBar progress={progress} />}
        </CardContent>
      </Card>

      <Card>
        <CardContent>
          <h3>Contact Details</h3>
          <FormGroup><label>Address</label><Input value={data.address} onChange={e=>setData({...data, address:e.target.value})} /></FormGroup>
          <FormGroup><label>Email</label><Input value={data.email} onChange={e=>setData({...data, email:e.target.value})} /></FormGroup>
          <FormGroup><label>Phone</label><Input value={data.phone} onChange={e=>setData({...data, phone:e.target.value})} /></FormGroup>
        </CardContent>
      </Card>
      
      <Button onClick={handleSave} style={{marginTop:'1rem'}} disabled={saving}>
        {saving ? 'Saving...' : 'Save Changes'}
      </Button>
    </Container>
  );
};

export default ContactAdmin;
